import { MessageCircle, ArrowUpRight } from "lucide-react";
import { waLink } from "../lib/constants";

export default function CTA() {
  return (
    <section
      data-testid="cta-section"
      className="relative bg-[var(--fb-bg)] py-20 md:py-28"
    >
      <div className="fb-container">
        <div className="relative overflow-hidden rounded-3xl bg-[var(--fb-ink)] text-white grain">
          <div
            className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full opacity-20 pointer-events-none"
            style={{
              background:
                "radial-gradient(closest-side, rgba(var(--fb-accent-rgb),1), transparent 70%)",
            }}
          />
          <div className="relative grid lg:grid-cols-12 gap-8 lg:gap-10 items-center p-8 md:p-14 lg:p-16">
            <div className="lg:col-span-7 reveal">
              <span className="eyebrow !text-white/70">
                ¿Tenés un proyecto en mente?
              </span>
              <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight balance leading-[1.02]">
                Solicitá tu presupuesto sin compromiso.
              </h2>
              <p className="mt-5 text-white/75 text-base md:text-lg max-w-xl pretty">
                Contanos qué necesitás y te respondemos por WhatsApp con un
                presupuesto a medida.
              </p>
            </div>
            <div
              className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-3 reveal"
              style={{ transitionDelay: "120ms" }}
            >
              <a
                data-testid="cta-whatsapp-btn"
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp justify-center !text-base"
              >
                <MessageCircle className="h-5 w-5" strokeWidth={2.4} />
                Hablar por WhatsApp
              </a>
              <a
                data-testid="cta-contact-btn"
                href="#contacto"
                className="btn-secondary justify-center !text-base"
              >
                Ver formas de contacto
                <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
